import type { DataTableColumn } from '@/components/ui/data-table-customized'
import { createOptionsFormatter } from '@/components/ui/data-table-customized'
import { Policy } from '../../../types'

export const getPolicyColumns = (): DataTableColumn<Policy>[] => [
    {
        key: 'name',
        title: 'Name',
        width: 400,
    },
    {
        key: 'displayName',
        title: 'Display Name',
        width: 200,
        valueGetter: (row) => row.displayName || '-',
    },
    {
        key: 'type',
        title: 'Type',
        width: 150,
        formatter: createOptionsFormatter({
            options: [
                { label: 'Role', value: 'role', color: 'primary' },
                { label: 'User', value: 'user', color: 'info' },
                { label: 'Client', value: 'client', color: 'success' },
                { label: 'JS', value: 'js', color: 'warning' },
                { label: 'Time', value: 'time', color: 'default' },
                { label: 'Aggregate', value: 'aggregate', color: 'default' },
                { label: 'Group', value: 'group', color: 'default' },
            ],
            renderMode: 'chip',
        }),
    },
    {
        key: 'logic',
        title: 'Logic',
        width: 120,
        formatter: createOptionsFormatter({
            options: [
                { label: 'Positive', value: 'POSITIVE', color: 'success' },
                { label: 'Negative', value: 'NEGATIVE', color: 'warning' },
            ],
            renderMode: 'chip',
        }),
    },
    {
        key: 'decisionStrategy',
        title: 'Decision Strategy',
        width: 150,
        valueGetter: (row) => row.decisionStrategy || '-',
    },
]
